import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { FiltersService } from '../../services/FiltersService';
import SimpleDropdown from './SimpleDropdown';

interface MasterDataDropdownProps {
  dropdownCode: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onDropdownLoad?: () => void;
  size?: 'large' | 'middle' | 'small';
}

const MasterDataDropdown: React.FC<MasterDataDropdownProps> = ({
  dropdownCode,
  value,
  onChange = () => {},
  placeholder = 'Select option',
  disabled = false,
  onDropdownLoad,
  size = 'large'
}) => {
  const [options, setOptions] = useState<{ key: string, label: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    loadOptions();
    // eslint-disable-next-line
  }, [dropdownCode]);

  const loadOptions = async () => {
    setLoading(true);
    setError('');
    try {
      const items = await FiltersService.getDropdownItems(dropdownCode);
      if (!items || items.length === 0) {
        setError('No options available');
        message.warning('No options available from the server');
      } else {
        const mappedOptions = items.map(item => ({
          key: (item.value || '').trim(),
          label: item.label || item.value || ''
        }));
        setOptions(mappedOptions);
      }
      if (onDropdownLoad) onDropdownLoad();
    } catch (error) {
      setError('Failed to load options');
      message.error('Failed to load options. Please try again.');
      if (onDropdownLoad) onDropdownLoad();
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (selected: string) => {
    onChange(selected);
  };

  return (
    <div>
      <SimpleDropdown
        options={options}
        value={value}
        onChange={handleChange}
        placeholder={loading ? 'Loading...' : error ? 'No options available' : placeholder}
        disabled={disabled || loading || !!error}
        size={size}
      />
      {error && (
        <div className="text-danger small mt-1">
          {error}
        </div>
      )}
    </div>
  );
};

export default MasterDataDropdown; 